/* eslint-disable prettier/prettier */
import LangGenerator from './LangGenerator';

export default LangGenerator({
  translation: {
    in: 'dalam',
    back: 'Kembali',
    totalPayment: 'Total Pembayaran',
    successPaymentMessage: 'Pembayaran Anda Berhasil',
    failedPaymentMessage: 'Pembayaran Anda Gagal',
    orderNumber: 'No Order',
    name: 'Nama',
    dateAndTime: 'Tanggal Dan Waktu',
    haveQuestion: 'Punya Pertanyaan',
    inHere: 'Lihat Disini',
    downloadInvoice: 'Download',
    processClaim: 'Proses Klaim',
    done: 'Selesai',
    usePromoCode: 'Gunakan Kode Promo',
    enterPromoCodeHere: 'Masukan kode promo disini',
    sorryPromoCode: 'Maaf!',
    failedReasonPromoCode:
      'Kode promo yang Anda masukkan sudah melebihi kuota atau tidak valid.',
    noPromoCode: 'Belum Ada Kode Promo',
    noPromoCodeInfo:
      'Untuk mendapatkan kode promo, Anda dapat melihat di  acara dan media sosial kami.',
    validUntilPromoCode: 'Valid sampai dengan',
    promoAdd: 'Tambah',
    promoRemove: 'Hapus',
    selectViaMap: 'Pilih Dari Map',
    useCurrentLocation: 'Gunakan lokasi sekarang',
    locationNotDetected: 'Lokasi Anda tidak terdeteksi',
    locationNotDetectedCause:
      'Kami tidak bisa mendeteksi lokasi Anda. Mohon nyalakan GPS pada perangkat Anda terlebih dahulu.',
    locationNotDetectedCauseBlocked:
      'Kami tidak memiliki izin untuk mengakses lokasi Anda. Anda dapat mencari alamat secara manual atau berikan akses lokasi melalui pengaturan browser',
    searchMyAddress: 'Cari Alamat Saya',
    turnOnGPS: 'Nyalakan GPS',
    findMapManually: 'Pilih Manual dari Peta',
    addDeliveryAddress: 'Tambah Alamat Pengiriman',
    setDeliveryLocation: 'Alamat Pengiriman',
    useThisAddress: 'Gunakan Alamat Ini',
    lifepackServiceCoverageMistake: 'Maaf, ini kesalahan kami',
    lifepackServiceIsAvailable: 'Saat ini Lifepack hanya tersedia di',
    lifepackServiceSorry:
      'Kami mohon maaf wilayah Anda belum dapat kami jangkau.',
    OK: 'OK',
    searchNearestDeliveryLocation: 'Cari Alamat Pengiriman Terdekat',
    searchLocation: 'Tulis nama jalan/gedung/perumahan',
    searchLocationHelper:
      'Pilih lokasi terdekat (gedung, jalan, kelurahan, dsb.) jika alamat Anda tidak muncul dalam pencarian.',
    selectFromMap: 'Pilih dari peta',
    savedAddressEmptyState:
      'Anda belum memiliki alamat tersimpan. Cari alamat Anda untuk menentukan alamat pengiriman.',
    addressNotFound: 'Tidak Ditemukan',
    patientName: 'Nama Pasien',
    phoneNumber: 'Nomor HP Pasien',
    membership: 'Member',
    regular: 'Reguler',
    patientAddress: 'Alamat Pasien',
    note: 'Catatan',
    medicationDate: 'Tanggal Pengobatan',
    medicationList: 'Daftar Obat',
    medicationOnly: 'Hanya Obat',
    paymentDetail: 'Rincian Pembayaran',
    subTotal: 'Subtotal',
    memberDiscount: 'Diskon Member',
    discount: 'Diskon',
    deliveryFee: 'Biaya Pengiriman',
    pickupFee: 'Biaya Pengambilan',
    medicationDiscount: 'Diskon Obat',
    enterPromoCode: 'Lebih hemat dengan promo',
    shippingOption: 'Opsi Pengiriman',
    confirm: 'Konfirmasi',
    confirmation: 'Konfirmasi',
    confirmationDescriptionConsultationOnly:
      'Silahkan periksa pesanan Anda sebelum checkout.',
    byPressTermsAndCondition: 'Dengan mencentang ini, berarti Anda menyetujui',
    termsAndCondition: 'Persyaratan Kondisi dan Kebijakan Privasi kami',
    addressNote: 'Detail Lokasi',
    addressNoteExample: 'Tulis patokan, nomor rumah, RT/RW, dll.',
    durationUnitHours: 'jam',
    durationUnitHour: 'jam',
    durationUnitDays: 'hari',
    durationUnitDay: 'hari',
    received: 'Diterima',
    receivedOn: 'Diterima pada',
    afterPickedByCourier: 'setelah di jemput oleh kurir',
    deliveryDistanceExceedLimit: 'Jarak pengiriman melebihi batas',
    serviceNotAvailable: 'Layanan Tidak Tersedia',
    promoCantBeApplied: 'Kode promo tidak dapat digunakan untuk pesanan ini.',
    promoReachMaxUsed: 'Kode promo ini telah digunakan hingga batas maksimal.',
    completeYourPayment: 'Selesaikan Pembayaran Kamu',
    startFrom: 'mulai dari',
    close: 'Tutup',
    chooseLanguage: 'Pilih bahasa Anda',

    medicalProvisions: 'Pengawasan Pengobatan',
    orderContainsOneOrMoreObatKeras:
      'Pesanan Anda mengandung satu atau lebih Obat Keras (daftar G), sehingga harus ',
    pickedUpAtOurPharmacy: 'diambil di apotek kami ',
    withIts: ' dengan ',
    originalPrescription: 'menyerahkan resep asli',
    doYouAgreeToProceed: 'Apakah anda bersedia?',
    b2bAgreeToPickup:
      'Saya bersedia untuk mengambil obat saya di Apotek Lifepack (self pickup).',
    b2cAgreeToPickup:
      'Saya bersedia untuk menyerahkan resep asli (fisik) dan mengambil obat saya di Apotek Lifepack (self pickup).',
    rejectAndCancelOrder: 'Tolak & Batalkan Pesanan',
    yourOrderWillBeCanceled:
      'Pesanan Anda akan dibatalkan secara permanen. Anda dapat berkonsultasi dengan dokter kami untuk mendapatkan resep baru untuk obat Anda.',
    areYouSureCancelOrder:
      'Apakah Anda yakin untuk menolak dan membatalkan pesanan?',
    noRevokeCancelation: 'Tidak, cabut pembatalan',
    yesCancelMyOrder: 'Ya, batalkan pesanan saya',

    pendingAddressTitle: 'Lengkapi Pesanan',
    pendingAddressDesc:
      'Silakan periksa Profil & Daftar Obat Anda sebelum melanjutkan.',

    paymentOrderTitle: 'Konfirmasi pengiriman',
    paymentOrderDesc:
      'Silahkan konfirmasi alamat dan opsi pengiriman Anda sebelum checkout.',

    prescriptionApprovedTitle: 'Resep Disetujui',
    prescriptionApprovedDesc:
      'Silakan periksa pesanan obat Anda sebelum checkout.',

    waitingForPaymentTitle: 'Menunggu Pembayaran',
    waitingForPaymentDesc: 'Harap lengkapi pembayaran Anda sebelum',

    paymentSuccessfulTitle: 'Pembayaran Berhasil',
    paymentSuccessfulDesc: 'Terima kasih, pembayaran Anda berhasil.',

    paymentExpiredTitle: 'Kadaluwarsa',
    paymentExpiredDesc:
      'Pembayaran telah kadaluwarsa karena melewati batas waktu.',

    orderCanceledTitle: 'Pesanan Dibatalkan',
    orderCanceledDesc: 'Pesanan telah dibatalkan atas permintaan Anda.',

    paymentFailedTitle: 'Pembayaran Gagal',
    paymentFailedDesc: 'Pembayaran Anda dibatalkan oleh sistem.',
    receiptFee: 'Biaya Layanan',

    onDelivery: 'Diantar',
    inReview: 'Resep Direview',
    prescriptionRejected: 'Resep Ditolak',
    orderProcessed: 'Sedang Diproses',
    orderCanceled: 'Pesanan Dibatalkan',
    waitingForPickup: 'Menunggu Kurir',
    pickedUp: 'Diambil Kurir',
    delivered: 'Diterima',
    deliveryFailed: 'Pengantaran gagal',
    active: 'Aktif',
    inActive: 'Tidak Aktif',
    patient: 'Pasien',

    paymentMethodNotRegistered:
      'Maaf, pengguna tidak terdaftar sebagai yang tertanggung.',
    paymentMethod: 'Metode Pembayaran',
    choosePaymentMethod: 'Pilih metode pembayaran',
    pagu: 'Pagu',
    insufficientBalance: 'Saldo Tidak Cukup',
    payWithoutPagu: 'Bayar tanpa Pagu',
    otherPay: 'Bayar',

    change: 'Ubah',
    contactUs: 'Hubungi Kami',
    checkOut: 'Bayar',
    payNow: 'Bayar Sekarang',
    continue: 'Lanjutkan',
    timeRemaining: 'Sisa Waktu',
    promoNotAllPaymentMethod:
      'Promo ini akan mengarahkan ke metode pembayaran tertentu dan tidak dapat diubah setelah checkout.',
    changePaymentMethod: 'Ganti Metode Pembayaran',
    needHelp: 'Butuh Bantuan? ',
    changeBranch: 'Ubah Cabang?',
    contactLifepackCare: 'Hubungi CS Lifepack',
    selectFromSavedAddresses: 'Pilih dari alamat tersimpan',
    pickupAtLifepackPharmacy: 'Ambil di Apotek Lifepack',
    deliveryAddress: 'Alamat Pengiriman',
    pickupAddress: 'Alamat Penjemputan',
    selfPickup: 'Pengambilan Sendiri',
    mustGiveOriginalPrescription:
      'Anda harus memberikan resep asli Anda kepada apoteker kami saat mengambil obat Anda.',
    pleaseBringOriginalPrescription:
      'Mohon membawa resep asli Anda ketika mengambil obat.',
    yourMedicineCanbePickedUpAt: 'Obat anda dapat diambil di',
    medicineShouldbePickedUp: 'Obat ini harus diambil di apotik',
    openMap: 'Buka Peta',
    openGoogleMap: 'Buka Google Map',
    payWithPagu: 'Bayar dengan Pagu',
    payWithPartner: 'Bayar dengan Penjamin',
    patientInformation: 'Informasi Pasien',
    pleaseCompleteYourPayment: 'Mohon segera melakukan pembayaran',
    transferBefore: 'Transfer sebelum',
    transactionAutomaticallyCanceled:
      'atau transaksi Anda akan otomatis dibatalkan oleh sistem.',
    amountPaid: 'Total Bayar',
    transferTo: 'Tranfer ke',
    totalToBePaid: 'Total yang harus dibayar',
    copy: 'Salin',
    yourTransactionIsBeingChecked:
      'Transaksi Anda sedang dicek, Mohon tunggu sebentar',
    orderInfo: 'Order Info',
    paymenIsMade: 'Pembayaran dilakukan ke akun',
    howToPay: 'Cara Bayar',
    usePaymentWithPagu: 'Pembayaran dengan Pagu',
    usePaymentWithPartner: 'Pembayaran dengan Penjamin',
    shippingAddressConfirmation: 'Konfirmasi Alamat Pengiriman',
    pinpoint: 'Pinpoint',
    fullAddressLabel: 'Alamat Lengkap',
    fullAddressPlaceholder: 'Tulis alamat lengkap',
    fullAddressHelperText:
      'Anda dapat mengubah kolom isian di atas untuk melengkapi alamat.',
    locationDetailLabel: 'Detail Lokasi (Tidak Wajib)',
    locationDetailPlaceholder: 'Tulis patokan, warna rumah, dll',
    saveAddressLabel: 'Simpan alamat untuk pesanan berikutnya',
    savedAddressLabel: 'Label Alamat',
    savedAddressPlaceholder: 'Cth: Rumah, Kantor',
    unsavedAddressPlaceholder: 'Alamat tidak disimpan',
    confirmAddress: 'Konfirmasi Alamat',

    orderExpiredTitle: 'Kadaluwarsa',
    orderExpiredDesc:
      'Sistem telah membatalkan pesanan Anda karena sudah melewati batas waktu.',
    sip: 'SIP',
    errorTitleCheckOutNoDeliveryOption: 'Maaf, terjadi kesalahan di kami.',
    errorMessageCheckOutNoDeliveryOption:
      'Kami mengalami masalah pada kurir pengiriman kami. Harap ubah ke opsi pengiriman lain.',
    consultationFee: 'Biaya Konsultasi',

    unsubscribe: 'Berhenti Langganan',
    requesting: 'Meminta',
    unsubscribeSuccess: 'Berhasil Berhenti Langganan',
    operationalHours: 'Jam Operasional',
    tax: 'PPN',
    sameDayDeliveryAfter:
      'Pembayaran diatas pukul 14.00, akan dikirimkan esok hari',
    deleteUser: 'Hapus Akun',
    deleteUserWillRemoveData:
      'Mengapus akun akan menghilangkan informasi profil dan riwayat pengobatan secara permanen.',
    inputPhoneNumber: 'Masukkan Nomor Telepon',
    deleteUserReason: 'Alasan Hapus Akun',
    applicationNotWorking: 'Aplikasi tidak bekerja dengan baik',
    cannotFindMedicine: 'Tidak dapat menemukan obat saya',
    manyMedicationNotAvailable: 'Banyak obat yang tidak tersedia',
    iDontNeed: 'Saya tidak membutuhkannya lagi',
    others: 'Lainnya',
    tellUsReason: 'Mohon beri tahu alasan Anda',
    optional: 'Opsional',
    inputOtpCode: 'Input Kode OTP',
    inputOtpCodeSentTo: 'Masukkan kode OTP yang telah dikirim ke',
    submit: 'Submit',
    accountNotFound: 'Akun tidak ditemukan',
    accountNotFoundCaption: 'Silakan masukkan nomor telepon yang terdaftar.',

    deleteAccountSuccess: 'Berhasil menghapus akun',
    accountDeletedWishGoodHealth:
      'Akun Anda berhasil dihapus. Semoga Anda sehat selalu!',
    deleteAccountFailed: 'Gagal menghapus akun',
    problemDeleteAccountContactCS:
      'Ada masalah dalam penghapusan akun Anda. Harap menghubungi CS Lifepack untuk informasi lebih lanjut.',
    deleteAccountFailedCaption:
      'Silakan masukkan nomor telepon yang terdaftar.',
    wrongOtp: 'Kode OTP yang Anda masukkan salah. Silakan coba lagi',
    otpSent: 'OTP telah dikirim',
    resendOtp: 'Kirim Ulang OTP',

    quizScore: 'Skor Kuis',
    youHaveATendencyOf: 'Anda memiliki kecenderungan',
    yourCondition: 'Kondisi Anda saat ini',
    mildDepression: 'Depresi Ringan',
    mildDepressionSuggestion:
      'Anda tetap dapat melanjutkan aktivitas sehari-hari, namun dengan semangat dan minat yang berkurang. Lakukan konsultasi dengan tenaga profesional apabila terjadi perburukan gejala.',
    moderateDepression: 'Depresi Sedang',
    moderateDepressionSuggestion:
      'Anda masih menjalani kehidupan sehari-hari, tetapi dengan susah payah dan mungkin merasa lelah secara fisik dan mental di penghujung hari. Lakukan psikoterapi untuk memahami pikiran, perasaan, dan gejala yang Anda alami.',
    moderatelySevereDepression: 'Depresi Sedang Menuju Berat',
    moderatelySevereDepressionSuggestion:
      'Anda mungkin terus mengalami bad mood atau gejala fisik Anda menjadi lebih parah. Anda merasa tidak termotivasi dan mulai menghindari aktivitas yang dulu Anda sukai. Konsultasikan dengan Psikiater untuk menentukan langkah apa yang harus diambil.',
    severeDepression: 'Depresi Berat',
    severeDepressionSuggestion:
      'Konsultasikan dengan psikiater sekarang untuk pemeriksaan secara mendetail & mendapat bantuan yang tepat. Jika tidak diatasi, depresi berat dapat membuat Anda kehilangan orang tersayang dan menurunkan kemampuan beraktivitas sehari-hari.',
    minimalSignDepression: 'Tidak Ada Gejala Depresi',
    minimalSignDepressionSuggestion:
      'Merupakan hal yang wajar jika terkadang Anda merasa sedih, namun jika Anda merasa sedang tidak baik-baik saja, jangan dipendam. Membuka diri dengan bercerita atau konsultasi dengan psikolog/psikiater dapat membantu Anda.',

    // ANCHOR: Consultation Forms
    selectDateAndTime: 'Pilih Tanggal & Waktu',
    doctorProfile: 'Profil Dokter',
    doctorFee: 'Biaya Dokter',
    youCanSelectSeveralConsultation:
      'Anda dapat memilih beberapa jadwal konsultasi sesuai dengan ketersediaan Anda.',
    next: 'Selanjutnya',
    symptomAndCondition: 'Keluhan',
    tellUsWhatYouFeel: 'Ceritakan keluhan Anda...',
    scheduleConsultation: 'Jadwalkan Konsultasi',
    inputPatientName: 'Masukkan nama pasien',
    selectConsultationDate: 'Pilih Tanggal Konsultasi',
  },
});
